import React from 'react';
import { Button } from './Button';
import { scrollToCompra } from '../utils/scroll';
import { ShieldCheck, Zap, Globe } from 'lucide-react';
export function Hero() {
  return <section className="bg-brand-cream pt-6 pb-8 px-4 relative" data-id="element-96">
      <div className="max-w-5xl mx-auto text-center" data-id="element-97">
        <h1 className="font-display text-xl md:text-3xl lg:text-4xl font-bold text-brand-navy leading-[1.15] uppercase mb-4 max-w-3xl mx-auto" data-id="element-98">
          Dejá de buscar. Todo lo que necesitás para enseñar{' '}
          <span className="green-highlight" data-id="element-99">Producción Acuícola</span> está acá,
          en un solo sistema.
        </h1>

        <div onClick={scrollToCompra} className="cursor-pointer max-w-2xl mx-auto mb-5 transform hover:scale-[1.02] transition-transform duration-300" data-id="element-100">
          <img src="https://cdn.magicpatterns.com/uploads/uGEwMnd9K4YrJECCn3XZtT/my-project-page-1_(5).png" alt="Sistema Acuicultura Pro — 6 tomos + materiales" className="w-full h-auto" data-id="element-101" />
        </div>

        <p className="text-sm md:text-lg text-brand-mute font-medium max-w-3xl mx-auto leading-snug mb-5" data-id="element-102">
          <span className="font-bold text-brand-ink" data-id="element-103">
            6 tomos técnicos, planificación anual lista, actividades de campo,
            evaluaciones con rúbrica y proyectos integradores.
          </span>{' '}
          Todo listo para usar el lunes.
        </p>

        <div className="max-w-md mx-auto mb-3" data-id="element-104">
          <Button data-id="element-105">🚀 Quiero el Sistema Acuicultura Pro</Button>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-5 text-[11px] md:text-sm text-brand-navy font-bold uppercase tracking-wide" data-id="element-106">
          <div className="flex items-center" data-id="element-107">
            <Zap className="w-4 h-4 mr-1 text-brand-green" data-id="element-108" /> Acceso inmediato
          </div>
          <div className="flex items-center" data-id="element-109">
            <ShieldCheck className="w-4 h-4 mr-1 text-brand-green" data-id="element-110" /> Garantía 7
            días
          </div>
          <div className="flex items-center" data-id="element-111">
            <Globe className="w-4 h-4 mr-1 text-brand-green" data-id="element-112" /> En tu moneda
            local
          </div>
        </div>
      </div>
    </section>;
}